import { createFileRoute } from '@tanstack/react-router';

import { MyPayrollPage } from '@/features/payroll/MyPayrollPage';

export const Route = createFileRoute('/_authed/admin/payroll')({
  component: MyPayrollPage,
});
